exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-0209a568]{margin-top:0}", ""]);

// exports
